export default {
  id: 2848,
  name: 'Manaus International Open IBJJF Jiu-Jitsu Championship 2025',
  dateStart: 'Sat, 27 Sep 2025 00:00:00 +0000',
  dateEnd: 'Sun, 28 Sep 2025 00:00:00 +0000',
  local: 'Arena Poliesportiva Amadeu Teixeira',
  localAddressLine1: 'Av. Constantino Nery, s/n',
  localAddressLine2: 'Flores',
  localAddressLine3: null,
  localAddressCity: 'Manaus',
  localAddressState: 'AM',
  localAddressZipcode: '69040-001',
  countryName: 'Brasil',
  prices: [
    {
      name: 'Standard',
      currency: 'real',
      values: [
        {
          dateStart: 'Fri, 28 Feb 2025 00:00:00 +0000',
          dateEnd: 'Fri, 29 Aug 2025 00:00:00 +0000',
          amount: 245.0,
          currency: 'real'
        },
        {
          dateStart: 'Sat, 30 Aug 2025 00:00:00 +0000',
          dateEnd: 'Fri, 19 Sep 2025 00:00:00 +0000',
          amount: 267.0,
          currency: 'real'
        }
      ]
    }
  ],
  isCombo: true,
  comboPrices: [
    {
      dateLimit: 'Fri, 28 Feb 2025 00:00:00 +0000',
      currency: 'real',
      priceBase: 490.0,
      priceDiscount: 57.0,
      priceFinal: 433.0
    },
    {
      dateLimit: 'Sat, 30 Aug 2025 00:00:00 +0000',
      currency: 'real',
      priceBase: 534.0,
      priceDiscount: 71.0,
      priceFinal: 463.0
    }
  ],
  comboName: 'Manaus International Open IBJJF 2025 - Combo',
  comboOptions: [
    {
      id: 2849,
      name: 'Manaus International Open IBJJF Jiu-Jitsu No-Gi Championship 2025',
      dateStart: 'Sat, 27 Sep 2025 00:00:00 +0000',
      dateEnd: 'Sun, 28 Sep 2025 00:00:00 +0000',
      local: 'Arena Poliesportiva Amadeu Teixeira',
      localAddressLine1: 'Av. Constantino Nery, s/n',
      localAddressLine2: 'Flores',
      localAddressLine3: null,
      localAddressCity: 'Manaus',
      localAddressState: 'AM',
      localAddressZipcode: '69040-001',
      countryName: 'Brasil',
      prices: [
        {
          name: 'Standard',
          currency: 'real',
          values: [
            {
              dateStart: 'Fri, 28 Feb 2025 00:00:00 +0000',
              dateEnd: 'Fri, 29 Aug 2025 00:00:00 +0000',
              amount: 245.0,
              currency: 'real'
            },
            {
              dateStart: 'Sat, 30 Aug 2025 00:00:00 +0000',
              dateEnd: 'Fri, 19 Sep 2025 00:00:00 +0000',
              amount: 267.0,
              currency: 'real'
            }
          ]
        }
      ]
    }
  ]
}
